<template>
    <div class="new-game-detail-home" :class="{ 'new-game-detail-home--tabbar': showGameFooterTabbar }">
      <Header :game="game" :match="match" :liveStatus="liveStatus" :stages="stages" :sport-type="sportType" />
      <van-tabs
        v-model="active"
        scrollspy
        sticky
        class="game-detail-tabs"
      >
        <van-tab title="视频&集锦">
          <div class="game-detail-tab-pane">
            <VideoCard
              v-if="hasVideoLiveContent"
              :game="game"
              :match="match"
              :live-status="liveStatus"
              :lives="lives"
              :game-id="gameId"
            />
            <div v-else class="game-detail-section-card">
              <div class="game-detail-section-card__title">视频&集锦</div>
              <div class="game-detail-section-card__empty">本场比赛暂未开通直播</div>
            </div>
          </div>
        </van-tab>
        <van-tab title="赛况">
          <div class="game-detail-tab-pane">
            <Outs v-if="hasOutsContent" :info="info" />
            <div v-else class="game-detail-section-card">
              <div class="game-detail-section-card__title">赛况</div>
              <div class="game-detail-section-card__empty">暂无赛况信息</div>
            </div>
          </div>
        </van-tab>
        <van-tab title="MVP">
          <div class="game-detail-tab-pane">
            <Mvp v-if="hasMvpContent" :mvp="mvp" />
            <div v-else class="game-detail-section-card">
              <div class="game-detail-section-card__title">MVP</div>
              <div class="game-detail-section-card__empty">本场暂无 MVP</div>
            </div>
          </div>
        </van-tab>
        <van-tab title="数据">
          <div class="game-detail-tab-pane game-detail-tab-pane--data">
            <DataPlate
              v-if="hasDataContent"
              :game-id="gameId"
              :game-event="gameEvent"
              :home-team-id="homeTeamId"
              :away-team-id="awayTeamId"
              :sport-type="sportType"
              :basketball-technical-data="basketballTechnicalData"
              :home-team-name="game.homeName || ''"
              :away-team-name="game.awayName || ''"
              :home-team-icon="game.homeIcon"
              :away-team-icon="game.awayIcon"
              :home-score="game.homeScore"
              :away-score="game.awayScore"
            />
            <div v-else class="game-detail-section-card">
              <div class="game-detail-section-card__title">数据</div>
              <div class="game-detail-section-card__empty">暂未录入比赛数据</div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div v-if="showGameFooterTabbar" class="new-game-detail-footer">
        <game-tabbar
          :unionMatchId="footerUnionMatchId"
          :matchId="footerMatchId"
          :gameId="gameId"
          :homeTeamId="String(homeTeamId || '')"
          :homeTeamName="tabbarHomeTeamName"
          :awayTeamId="String(awayTeamId || '')"
          :awayTeamName="tabbarAwayTeamName"
          :registrationCapability="registrationCapabilityForTabbar"
        />
      </div>
    </div>
</template>

<script>
import { Tabs, Tab } from 'vant'
import { getBMGameDetail, getBMGameBktData } from '@/api/match'
import Header from './components/header.vue'
import Outs from './components/outs.vue'
import VideoCard from './components/videoCard.vue'
import DataPlate from './components/dataPlate.vue'
import Mvp from './components/mvp.vue'
import GameTabbar from '@/views/match-team-game/game-tabbar.vue'
import { QNImageUtil, DateUtil } from '@/utils'
import { hasMatchOutsData } from './matchOutsHelpers'

export default {
  components: {
      Header,
      Outs,
      VideoCard,
      DataPlate,
      Mvp,
      GameTabbar,
      'van-tabs': Tabs,
      'van-tab': Tab,
  },
  data() {
    return {
      active: 0,
      gameId: '',
      homeTeamId: '',
      awayTeamId: '',
      game: {},
      match: {},
      info: {},
      liveStatus: null,
      stages: [],
      lives: [],
      mvp: null,
      gameEvent: [],
      sportType: '',
      basketballTechnicalData: [],
      footerUnionMatchId: '',
      footerMatchId: '',
      gameRollCall: 0,
      tabbarHomeTeamName: '',
      tabbarAwayTeamName: '',
      jetlympic: false,
    };
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    this.gameId = this.$route.params.gameId
    this.getGameDetail()
  },
  computed: {
    /** 与 VideoCard 一致：无 liveStatus 或 status===-1 视为无直播/视频区块 */
    hasVideoLiveContent() {
      const ls = this.liveStatus
      if (!ls || typeof ls !== 'object') return false
      if (Number(ls.status) === -1) return false
      return true
    },
    hasOutsContent() {
      return hasMatchOutsData(this.info)
    },
    hasMvpContent() {
      return !!this.mvp
    },
    /** 篮球：技术统计非空或可展示总分条；足球：有条目事件 */
    hasDataContent() {
      const st = this.sportType || ''
      if (st === '足球') return Array.isArray(this.gameEvent) && this.gameEvent.length > 0
      if (st === '篮球') {
        const tech =
          Array.isArray(this.basketballTechnicalData) && this.basketballTechnicalData.length > 0
        return tech || this.hasRenderableBasketballScoreRow
      }
      return false
    },
    hasRenderableBasketballScoreRow() {
      const hs = this.game.homeScore
      const as = this.game.awayScore
      if (hs == null || as == null || hs === '' || as === '') return false
      const nh = Number(hs)
      const na = Number(as)
      if (Number.isNaN(nh) || Number.isNaN(na)) return false
      if (nh === -1 || na === -1) return false
      return true
    },
    /** 足球赛且非 jetlympic：展示与活动页一致的场地底部操作栏 */
    showGameFooterTabbar() {
      return this.sportType === '足球' && !this.jetlympic && !!this.gameId
    },
    registrationCapabilityForTabbar() {
      return Number(this.gameRollCall) === 1
    },
  },
  methods: {
    /**
     * 两黄变一红：后端会多出一条 type=red，并保留第二条 type=yellow。
     * 剔除该球员「第二条黄牌」记录，将该条冗余的 red 改为 yellowRed。
     */
    /**
     * 按运动类型处理 gameEvent；仅足球：两黄合并 + 点球大战抽离合并后拼在末尾。
     */
    buildGameEventList(raw, sportType, homeTeamId, awayTeamId) {
      if (!Array.isArray(raw)) return []
      if (sportType !== '足球') return raw.slice()

      const home = homeTeamId != null ? String(homeTeamId) : ''
      const away = awayTeamId != null ? String(awayTeamId) : ''
      const withoutPs = raw.filter(e => e && e.type !== 'penaltyShootoutShot')
      const main = this.normalizeGameEventsForYellowRed(withoutPs)
      const shootouts = raw.filter(e => e && e.type === 'penaltyShootoutShot')
      const rounds = this.mergePenaltyShootoutRounds(shootouts, home, away)
      return [...main, ...rounds]
    },
    /**
     * 相同 time 的主、客队各一条点球大战射门 → 合并为一行，home/away 存队员信息与 goalCount（1 命中，0 未命中）
     */
    mergePenaltyShootoutRounds(events, homeId, awayId) {
      if (!events.length) return []
      const byTime = {}
      events.forEach(ev => {
        const t = Number(ev.time) || 0
        if (!byTime[t]) byTime[t] = { home: null, away: null }
        const tid = ev.teamId != null ? String(ev.teamId) : ''
        const shot = {
          goalCount: ev.goalCount != null ? Number(ev.goalCount) : 0,
          userNumber: ev.userNumber,
          userName: ev.userName,
        }
        if (homeId && tid === homeId) byTime[t].home = shot
        else if (awayId && tid === awayId) byTime[t].away = shot
        else if (!byTime[t].home) byTime[t].home = shot
        else if (!byTime[t].away) byTime[t].away = shot
      })
      return Object.keys(byTime)
        .sort((a, b) => Number(a) - Number(b))
        .map(tk => ({
          id: `penalty-shootout-round-${tk}`,
          type: 'penaltyShootoutRound',
          time: Number(tk),
          home: byTime[tk].home,
          away: byTime[tk].away,
        }))
    },
    normalizeGameEventsForYellowRed(events) {
      if (!Array.isArray(events) || events.length === 0) return []
      const withIdx = events.map((ev, i) => ({ ev, i }))
      const sorted = [...withIdx].sort((a, b) => {
        const dt = (Number(a.ev.time) || 0) - (Number(b.ev.time) || 0)
        if (dt !== 0) return dt
        return a.i - b.i
      })

      const toRemove = new Set()
      /** @type {Map<string, 'yellowRed'>} */
      const typePatch = new Map()
      const yellowQueueByPlayer = {}

      for (const { ev } of sorted) {
        const pid =
          ev.playerId != null && String(ev.playerId).trim() !== ''
            ? String(ev.playerId)
            : ''
        if (!pid) continue

        if (ev.type === 'yellow') {
          if (!yellowQueueByPlayer[pid]) yellowQueueByPlayer[pid] = []
          yellowQueueByPlayer[pid].push(String(ev.id))
        } else if (ev.type === 'red') {
          const queue = yellowQueueByPlayer[pid]
          if (queue && queue.length >= 2) {
            toRemove.add(queue[1])
            typePatch.set(String(ev.id), 'yellowRed')
            yellowQueueByPlayer[pid] = queue.slice(2)
          }
        }
      }

      return withIdx
        .filter(({ ev }) => !toRemove.has(String(ev.id)))
        .sort((a, b) => a.i - b.i)
        .map(({ ev }) => {
          const id = String(ev.id)
          if (typePatch.has(id)) {
            return { ...ev, type: typePatch.get(id) }
          }
          return { ...ev }
        })
    },
    getGameDetail() {
      getBMGameDetail({  gameId: this.gameId }).then(res => {
        const data = (res && res.data) || {}
        const game = data.game || {}
        const sportType = this.resolveSportType(game)
        this.sportType = sportType
        const chineseName =
          game.match && game.match.chineseName != null ? String(game.match.chineseName) : ''
        const nameParts = chineseName.split('_')
        const match = {
          name: nameParts[0] || '',
          groupName: nameParts[1] || '',
          icon: game.match && game.match.icon ? QNImageUtil.imageView(game.match.icon) : '',
        }
        this.match = {
          ...match,
          unionMatchId: game.unionMatchId
        }
        this.game = {
          id: game.id,
          roundDescription: game.roundDescription,
          sportType,
          homeName: game.homeTeamAlias || game.homeTeamName,
          awayName: game.awayTeamAlias || game.awayTeamName,
          homeIcon: QNImageUtil.imageView(game.homeTeamBadge || game.matchIcon),
          awayIcon: QNImageUtil.imageView(game.awayTeamBadge || game.matchIcon),
          homeScore: game.homeScore,
          awayScore: game.awayScore,
          homePenalty: game.homePenalty,
          awayPenalty: game.awayPenalty,
          status: game.status,
          gameNotBegin: game.gameNotBegin,
          gameEnd: game.gameEnd,
          name: game.name,
          beginDate: DateUtil.parseDateTime(game.beginDate, '{y}/{m}/{d} {h}:{i}:{s}'),
          pvCount: game.pvCount,
          type: game.type
        }
        console.log(sportType);
        
        if (sportType === '篮球' || sportType === '网球') {
          this.loadBasketballStages()
        } else if (this.isRacketSportType(sportType)) {
          this.loadRacketSportStages(game.gameSub)
          this.basketballTechnicalData = []
        } else {
          this.stages = []
          this.basketballTechnicalData = []
        }
        this.lives = Array.isArray(data.lives)
          ? data.lives.map(item => ({
              videoId: item.videoId,
              poster: QNImageUtil.imageView(item.poster),
              title: item.title
            }))
          : []
        const livePoster =
          game.liveStatus && game.liveStatus.poster
            ? QNImageUtil.imageView(game.liveStatus.poster)
            : ''
        this.lives.unshift({
          videoId: '',
          poster: livePoster,
          title: '视频录像'
        })
        this.info = {
          beginDate: game.beginDate || '',
          endDate: game.endDate || '',
          location: game.location,
          referee: Array.isArray(game.referee) ? game.referee : [],
        }
        this.mvp = game.mvp && {
          playerName: game.mvp.trueName,
          teamName: game.mvp.teamName,
          avatar: game.mvp && game.mvp.avatar && QNImageUtil.imageView(game.mvp.avatar),
          teamBadge: game.mvp.teamBadge && QNImageUtil.imageView(game.mvp.teamBadge),
          number: game.mvp.number
        }
        this.liveStatus = game.liveStatus || null
        const homeId = game.homeTeamId != null ? game.homeTeamId : ''
        const awayId = game.awayTeamId != null ? game.awayTeamId : ''
        this.homeTeamId = homeId
        this.awayTeamId = awayId
        this.footerUnionMatchId =
          game.unionMatchId != null ? String(game.unionMatchId) : ''
        this.footerMatchId = game.matchId != null ? String(game.matchId) : ''
        this.gameRollCall = game.rollCall != null ? Number(game.rollCall) : 0
        this.tabbarHomeTeamName = String(
          game.homeTeamName || game.homeTeamAlias || ''
        ).trim()
        this.tabbarAwayTeamName = String(
          game.awayTeamName || game.awayTeamAlias || ''
        ).trim()
        if (!this.tabbarHomeTeamName) this.tabbarHomeTeamName = String(this.game.homeName || '').trim()
        if (!this.tabbarAwayTeamName) this.tabbarAwayTeamName = String(this.game.awayName || '').trim()
        this.gameEvent = this.buildGameEventList(
          Array.isArray(game.gameEvent) ? game.gameEvent : [],
          game.sportType || sportType || '',
          homeId,
          awayId
        )
      })
    },
    resolveSportType(game) {
      const st = (game && (game.sportType || (game.match && game.match.sportType))) || ''
      return String(st).trim()
    },
    normalizeGameSub(gameSub) {
      if (gameSub == null || gameSub === '') return []
      if (typeof gameSub === 'string') {
        try {
          const parsed = JSON.parse(gameSub)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return Array.isArray(gameSub) ? gameSub : []
    },
    isRacketSportType(sportType) {
      return ['羽毛球', '乒乓球', '匹克球', '网球'].includes(String(sportType || '').trim())
    },
    loadRacketSportStages(gameSub) {
      const list = this.normalizeGameSub(gameSub)
      if (list.length === 0) {
        this.stages = []
        return
      }
      this.stages = list.map((item, index) => ({
        id: item.id != null ? item.id : index + 1,
        name: 'Set' + (item.seq != null ? item.seq : index + 1),
        homeScore: item.homeScore,
        awayScore: item.awayScore,
      }))
    },
    loadBasketballStages() {
      getBMGameBktData({ mode: 0, gameId: this.gameId }).then(res => {
        if (res === false || !res || !res.data) {
          this.stages = []
          this.basketballTechnicalData = []
          return
        }
        const data = res.data
        const game = data.game || {}
        const td = Array.isArray(data.technicalData)
          ? data.technicalData
          : Array.isArray(game.technicalData)
            ? game.technicalData
            : []
        this.basketballTechnicalData = td
        const rawStages = data.stages
        if (!Array.isArray(rawStages) || rawStages.length === 0) {
          this.stages = []
          return
        }
        const stages = rawStages
          .filter(item => item.homeScore !== -1 && item.awayScore !== -1)
          .map(item => ({
            id: item.id,
            name: 'Q' + item.seq,
            homeScore: item.homeScore,
            awayScore: item.awayScore,
          }))
        if (game.homePlus != null && game.awayPlus != null && game.homePlus !== -1 && game.awayPlus !== -1) {
          stages.push({
            id: 'OT',
            name: 'OT',
            homeScore: game.homePlus,
            awayScore: game.awayPlus,
          })
        }
        if (stages.length === 0) return
        if (game.homeScore != null && game.awayScore != null && game.homeScore !== -1 && game.awayScore !== -1) {
          stages.push({
            id: '总分',
            name: '总分',
            homeScore: game.homeScore,
            awayScore: game.awayScore,
          })
        }
        this.stages = stages
      }).catch(() => {
        this.stages = []
        this.basketballTechnicalData = []
      })
    },

    imageView(img) {
      return QNImageUtil.imageView(img)
    }
  },
};
</script>

<style scoped lang="scss">
.game-detail-tabs{
  background: #F8F8F8;
}
.game-detail-tabs::v-deep .van-tabs__line {
  background: #1989FA;
}
.game-detail-tab-pane {
  min-height: 8px;
  &--data {
    padding-bottom: 16px;
  }
}

/** 与各 Tab 无数据时空状态（留白块 + 标题 + 居中灰字），与设计稿一致 */
.game-detail-section-card {
  margin-top: 12px;
  margin-left: 0;
  margin-right: 0;
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px 16px;
  box-sizing: border-box;
}

.game-detail-section-card__title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.game-detail-section-card__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  padding: 12px 8px;
  font-size: 14px;
  font-weight: 400;
  color: #909399;
  text-align: center;
}

.new-game-detail-home--tabbar {
  padding-bottom: 50px;
  box-sizing: border-box;
}

.new-game-detail-footer {
  height: 0;
}
</style>
